/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetDataPanels($bbox: String!, $ids: [ID!]) {
    dataPanels(bbox: $bbox, ids: $ids) {
      id
      name
      description
      source
      tags
      bbox
      layerId
      layerUuid
      graphics {
        name
      }
    }
  }
`): DocumentNode);
